export default __webpack_public_path__ + "static/media/mypic5.631115ab.png";